/** @prettier */
import { API_ROOT, makeRequest } from "../services/qbankApi";

export type UserRegistrationData = {
    firstName: string;
    lastName: string;
    username: string;
    password?: string;
    token?: string;
    superuser?: boolean;
}

export async function initiateRegistration(user: UserRegistrationData): Promise<void> {
    const url = `${API_ROOT}initiateRegistration`;
    await makeRequest("POST", url, user);
}

export async function completeRegistration(user: UserRegistrationData): Promise<void> {
    const { token, ...postData } = user;
    postData.superuser = false;
    const url = `${API_ROOT}completeRegistration?token=${token}`;
    await makeRequest("POST", url, postData);
}

export async function fetchRegistration(token: string): Promise<UserRegistrationData> {
    const url = `${API_ROOT}fetchRegistration?token=${token}`;
    const res = await (await makeRequest("GET", url,)).json();
    return res as UserRegistrationData;
}

export async function initiatePasswordReset(email: string): Promise<void> {
    const url = `${API_ROOT}initiatePasswordReset`;
    await makeRequest("POST", url, { emailAddress: email });
}

export async function completePasswordReset(
    newPassword: string,
    token: string
): Promise<void> {
    const url = `${API_ROOT}completePasswordReset?token=${token}`;
    await makeRequest("POST", url, { newPassword });
}
